/**
 * Layout Utilities
 * 
 * Shared data preparation functions for Desktop and Mobile layouts.
 * These are pure functions that transform view data into props for child components.
 */

import type { AddressPageV2ViewData, AddressPageV2ViewHandlers } from '../address-page-v2-controller';
import type { AddressPageEventHandlers } from '../../shared';

/**
 * Prepares hero props from view data and handlers
 */
export function prepareHeroProps(data: AddressPageV2ViewData, handlers: AddressPageV2ViewHandlers) {
  const { 
    currency, 
    locale, 
    hasAccessRestriction,
    mlsCourtesyText, 
    mlsBuyerRepText, 
    virtualTourLabel, 
    onVirtualTourClick, 
    priceHistoryLabel,
    onPriceHistoryClick,
    priceHistoryRef,
    commonData,
    stickyFooterData,
  } = data;
  const { tenantId, listing, complianceRequirement, shouldScramble, listingSource } = commonData;
  const { onAddressClick } = handlers;

  return {
    listing,
    currency,
    locale,
    blur: hasAccessRestriction,
    mlsCourtesyText,
    mlsBuyerRepText,
    virtualTourLabel,
    onVirtualTourClick,
    priceHistoryLabel,
    onPriceHistoryClick,
    priceHistoryRef,
    onAddressClick,
    tenantId,
    complianceRequirement,
    shouldScramble,
    listingSource,
    share: stickyFooterData.share ? {
      ...stickyFooterData.share,
      listingId: listing.id,
    } : undefined,
  };
}

/**
 * Prepares event handlers from view data and handlers
 */
export function prepareEventHandlers(
  data: AddressPageV2ViewData, 
  handlers: AddressPageV2ViewHandlers
): AddressPageEventHandlers {
  const { stickyFooterData } = data;
  const { 
    onComplianceClick, 
    onTermsOfUseBannerDismiss,
    onSimilarListingsCardClick,
    onContactForPriceClick,
    onStickyHeaderTabClick,
    onViewListingClick,
    onRoomsShowDetailsClick,
  } = handlers;

  return {
    onComplianceRequirementClick: onComplianceClick
      ? (complianceRequirement, providerId) => onComplianceClick(complianceRequirement, providerId)
      : undefined,
    onTermsOfUseBannerDismiss,
    onSaveListingClick: stickyFooterData.favorite.onToggle ? () => stickyFooterData.favorite.onToggle?.() : undefined,
    onStickyHeaderTabClick,
    onSimilarListingsCardClick,
    onContactForPriceClick,
    onViewListingClick,
    onRoomsShowDetailsClick,
  };
}
